import { useState } from "react";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import PageHeader from "../../../components/pageHeader/pageHeader";
import style from "../../../components/PaymentInstallments/PaymentInstallments.module.css";
import PaymentInstallmentToggle from "../../../components/PaymentInstallments/PaymentInstallmentToggle";

/**
 * Admin screen of the Payment Installments feature: switch installments on or
 * off. The screen only lays the setting out; the change is made by
 * PaymentInstallmentToggle.
 */
export default function PaymentInstallments() {
  /** The header needs a search value even though this screen has no search. */
  const [searchQuery, setSearchQuery] = useState("");

  return (
    <div>
      <div className={style.bodyBox}>
        <PageHeader
          title="Payment Installments"
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          showSearchButton={false}
          showAdditionalButton={false}
          buttonTitle=""
          showGridButton={false}
          showFilterButton={false}
        />

        <p className={style.sectionTitle}>
          Let applicants pay a Demand Note in more than one receipt
        </p>
        <BoxComponent>
          <div className={style.settingRow}>
            <div className={style.settingText}>
              <p className={style.settingName}>Allow payment in installments</p>
              <p className={style.settingHint}>
                When on, an applicant can pay in up to 3 receipts. The payment
                goes to the Accountant once the receipts add up to the full
                amount. If the Accountant returns it, the applicant pays the
                full amount again in one receipt. A payment can be returned
                twice.
              </p>
            </div>
            <PaymentInstallmentToggle />
          </div>
        </BoxComponent>
      </div>
    </div>
  );
}
